import { MinicartCount } from './minicart-count';

class Minicart {
    constructor (element) {
        this.$minicart = element;
        this.$minicartCount = this.$minicart.querySelector('[data-cart-amount]');
        this.$minicartExpander = document.querySelector('[data-cart="expander"]');
        this.initialize();
    }

    initialize () {
        this.setEvents();

        if (this.$minicartCount) {
            const count = new MinicartCount();
            count.updateCountIndicator(this.$minicartCount.getAttribute('data-cart-amount'));
        }
    }

    setEvents () {
        this.$minicart.addEventListener('click', (e) => {
            if (e.target.dataset.cart === 'close' || e.target.dataset.cart === 'root') {
                if (this.$minicart.classList.contains('minicart--is-active')) {
                    this.$minicart.classList.remove('minicart--is-active');
                    this.$minicart.classList.remove('minicart--is-open-from');
                } else {
                    this.$minicart.classList.add('minicart--is-active');
                }
            }

            if (e.target.dataset.cart === 'full') {
                this.$minicart.classList.remove('minicart--is-open-from');
                this.$minicart.classList.add('minicart--is-active');
            }
        });

        this.$minicartExpander.addEventListener('click', (e) => {
            if (window.innerWidth < 1024) {
                e.preventDefault();
                this.$minicart.classList.add('minicart--is-active');
            }
        });

        this.$minicart.addEventListener('mouseleave', () => {
            this.$minicart.classList.remove('minicart--is-active');
        });
    }
}

export { Minicart };
